import { atom, selector } from "recoil";
import { rejectDeletionRequest, deleteDataRequest, createDataRequest, updateDataRequest, getVesselTypeListRequest, rejectDataRequest } from "../../../api/controller/VesselController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const vesselListState = atom({
    key: 'vesselListState',
    default: [],
})
export const vesselVesselTypeState = atom({
	key: 'vesselVesselTypeState',
	default:{
		data:[],
		ovf:false,
	}
})
export const vesselFilterStatusValueState = atom({
    key: 'vesselFilterStatusValueState',
    default: { label: "PENDING", value: "PENDING" },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const vesselFilterState = selector({
    key: 'vesselFilterState',
    get: ({ get }) => ([
        {
            label: 'Status',
            size: 6,
            offset: 6,
            required: true,
            type: 'select',
            value: get(vesselFilterStatusValueState),
            list: {
                ovf: false,
                data: [
                    { label: "PENDING", value: "PENDING" },
                    { label: "APPROVED", value: "APPROVED" },
                    { label: "REJECTED", value: "REJECTED" },
                    // Not registration statuses: a vessel awaiting removal is
                    // still APPROVED, and a removed one is soft-deleted. The API
                    // matches these as conditions rather than on the column.
                    { label: "DELETION REQUESTED", value: "DELETION REQUESTED" },
                    { label: "DELETED", value: "DELETED" },
                ]
            },
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'Status'){
            set(vesselFilterStatusValueState, e.value)
        }
    }
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [
        { name: 'Default Update', action: updateDataRequest },
        { name: 'Reject', action: rejectDataRequest, closeOnSubmit: true },
        // Declining a customer's removal request. Reuses the Rejection Reason
        // field, whose payload key is already RejectionReason.
        { name: 'Decline Removal', action: rejectDeletionRequest, closeOnSubmit: true },
        // Staff-initiated removal. A reason is required, as it is for
        // rejection: the vessel disappears from the customer's account and
        // they are told why.
        { name: 'Delete', action: deleteDataRequest, closeOnSubmit: true },
    ],
    view: [ { name: 'Default View' } ],
}

export const vesselDataStructureState = selector({
    key: 'vesselDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Vessel Type',
                type: 'select',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
				list: get(vesselVesselTypeState),
				getRequest: getVesselTypeListRequest,
            },
			{ 
                label: 'Registration Number',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{
                label: 'Length',
                type: 'number',
                order: { form: 4 },
                create: [{ enabled: true, size: { xs: 12, md: 4 }, subText: "in meters", attributes: { step: 'any', min: 0 } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'],
            },
			{
                label: 'Breadth',
                type: 'number',
                order: { form: 5 },
                create: [{ enabled: true, size: { xs: 12, md: 4 }, subText: "in meters", attributes: { step: 'any', min: 0 } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'],
            },
			{
                label: 'Gross Tonnage',
                type: 'number',
                order: { form: 6 },
                create: [{ enabled: true, size: { xs: 12, md: 4 }, attributes: { step: 'any', min: 0 } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'],
            },
			{ 
                label: 'Representative Name',
                type: 'text',
                order: { form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{
                label: 'Representative Contact Number',
                type: 'text',
                order: { form: 8 },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, subText: "",attributes: { maxLength: 7, inputMode: 'numeric' } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'],
            },
			{ 
                label: 'Registration Document',
                type: 'file',
                order: { form: 9 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Vessel Image',
                type: 'file',
                order: { form: 9.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{
                label: 'Status',
                type: 'text',
                order: { table: 4, form: 10 },
                create: [{ enabled: false }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 12 }  }],
            },
            {
                label: 'Approved By',
                type: 'text',
                field: 'approver.name',
                order: { form: 10.1 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:ApprovedBy,null' }],
            },
            {
                label: 'Approved At',
                type: 'text',
                field: 'approved_at_label',
                order: { form: 10.2 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:ApprovedAt,null' }],
            },
            {
                label: 'Deleted By',
                type: 'text',
                field: 'deleter.name',
                order: { form: 10.21 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:DeletedBy,null' }],
            },
            {
                label: 'Deleted At',
                type: 'text',
                field: 'deleted_at_label',
                order: { form: 10.22 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:DeletedAt,null' }],
            },
            {
                label: 'Resubmissions',
                type: 'text',
                field: 'resubmit_count',
                order: { form: 10.3 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:Resubmissions,0' }],
            },
            {
                label: 'Rejection Reason',
                type: 'textarea',
                order: { form: 10.5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0', { enabled: true, size: 12 }, { enabled: true, size: 12 }, { enabled: false }], view: [{ enabled: true, size: 12, validations: 'hidden_if:RejectionReason,null' }], 
            },
			{ 
                // Staff's reason for removing the vessel. Shown only in the
                // Delete mode; the customer is told what it says.
                label: 'Deletion Reason',
                type: 'textarea',
                order: { form: 10.6 }, 
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: true, size: 12 }], view: [{ enabled: true, size: 12, validations: 'hidden_if:DeletionReason,null' }], 
            },
			{ 
                label: 'Active',
                type: 'switch',
                order: { table: 5, form: 11 }, 
                create: [{ enabled: false }], update: [{ enabled: true, size: { xs: 12, md: 12 } }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
